module.exports = __webpack_public_path__ + "static/targeted-insights-dc9f0a674d4018a684c19afc321586a5.svg";